import React, { useEffect, useState } from 'react';
import { DialogDefault } from '../../../shared/components/dialog/DialogDefault';
import { Grid } from '@mui/material';
import { InputDefault } from '../../../shared/components/inputs/InputDefault';
import { openSnackbarAction } from '../../../shared/components/snackbar/snackbar-actions';
import { TypeMessage } from '../../../shared/components/snackbar/snackbar-types';
import { USER_ROLES_OPTIONS } from '../../../shared/constants';
import { Site, User, UserRoles, useUpdateUserandRolesMutation, useUpdateUserMutation } from '../../../shared/types/generated';
import { revertSanitizeUserRole, sanitizeUserRole } from '../../../shared/utils';
import { MultipleSelectDefault } from '../../../shared/components/inputs/MultipleSelectDefault';

type UpdateTenantUserDialogProps = {
  user: User | null;
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
};

export const UpdateTenantUserDialog: React.FC<UpdateTenantUserDialogProps> = ({
  user,
  open,
  onClose,
  onSuccess,
}) => {
  const [form, setForm] = useState<User | undefined>(undefined);
  const [roles, setRoles] = React.useState<string[]>([]);

  const [updateTenantUser, { loading }] = useUpdateUserandRolesMutation({
    onCompleted: () => {
      onSuccess();
      openSnackbarAction('Se ha actualizado el usuario con éxito', TypeMessage.SUCCESS);
    },
    onError: () => {
      openSnackbarAction('Tenemos problemas para actualizar elusuario', TypeMessage.ERROR);
    },
  });
  const onChangeRoles = (value: string[]): void => {
    setRoles(value);
  };
  const onChange = (field: string, value: string): void => {
    const newVal = {
      ...form,
      [field as keyof User]: value,
    } as User;

    setForm(newVal);
  };

  useEffect(() => {
    if (user) {
      setForm(user);
      setRoles(
        (user?.roles_on_users?.map((role) =>
          sanitizeUserRole(role?.role?.name as UserRoles),
        ) ?? []) as string[],
      );
    }
  }, [user]);

  if (!form) {
    return null;
  }

  return (
    <DialogDefault
      title={'ACTUALIZAR USUARIO'}
      isOpen={open}
      handleClose={() => onClose()}
      showActions
      isLoading={loading}
      handleSuccess={() => {
        updateTenantUser({
          variables: {
            data: {
              user: {
                id: form?.id,
                name: form?.name,
                site: Site.AnimalPolitico
              },
              newRoles: (roles.map((role) => revertSanitizeUserRole(role)) ??
                  []) as UserRoles[],
            },
          },
        });
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <InputDefault
            variant="outlined"
            labelName="Nombre"
            value={form?.name}
            name="name"
            onChangeData={onChange}
          />
        </Grid>
        <Grid item xs={12}>
          {/**<SelectDefault
            variant="outlined"
            labelName="Rol"
            value={form?.roles_on_users?.map((role) => role?.role?.name)}
            options={USER_ROLES_OPTIONS}
            name="role"
            onChangeData={onChange}
            disabled
          /> */}
          <MultipleSelectDefault
            labelName="Permisos"
            options={USER_ROLES_OPTIONS}
            onChangeData={onChangeRoles}
            valueIn={roles}
          />
        </Grid>
      </Grid>
    </DialogDefault>
  );
};
